export enum BusinessSectorEnum {
  COMBUSTIBLES = 1,
  RESTAURANTES,
  HIPERMERCADOS_SUPERMERCADOS_ALMACENES,
  TODOS,
}
